import React from 'react'
import { useHistory, useRouteMatch } from 'react-router-dom'
import { DeleteOptionsProps } from '@cbgms/components/widgets/Knock/KnockWidget'
import { DeleteModalProps as DeleteModalContainerProps } from '../list-wrapper/ListWrapper'

export const navigateUp = (path: string) => path.split('/').slice(0, -1).join('/')

export interface DeleteModalProps {
  onDelete?: (checkIfDeleteIsPossible?: boolean, reason?: string) => Promise<void>
  translationKey: string
  /** A string containing an URL to redirect to when the regular redirect behaviour isn't enough. */
  redirectToURL?: string
  skipDryRun?: boolean
  skipCloseModal?: boolean
  deleteReasons?: DeleteOptionsProps[]
  DeleteModalContainer: React.ComponentType<DeleteModalContainerProps>
  showMultiple?: boolean
}

function withDeleteModal(WrappedComponent: React.ComponentType<any>) {
  function DeleteModal(props: DeleteModalProps) {
    const { DeleteModalContainer } = props
    const [open, setOpen] = React.useState(false)
    const N = useHistory()
    const match = useRouteMatch()

    const onDelete = props.onDelete ? () => setOpen(true) : undefined
    const onClose = () => setOpen(false)
    const handleRemove = async (checkIfDeleteIsPossible?: boolean, reason?: string) => {
      const { onDelete, redirectToURL } = props

      try {
        const result = await onDelete?.(checkIfDeleteIsPossible, reason)

        if (!checkIfDeleteIsPossible) {
          N.push(redirectToURL || navigateUp(match.url))
        }

        return result
      } catch {
        return null
      }
    }

    return (
      <>
        <WrappedComponent {...props} onDelete={onDelete} />
        {open && (
          <DeleteModalContainer
            data-testid='delete-modal'
            showModal={open}
            closeModal={onClose}
            translationKey={props.translationKey}
            handleRemove={handleRemove}
            skipDryRun={props.skipDryRun}
            skipCloseModal={props.skipCloseModal}
            deleteReasons={props.deleteReasons || []}
            showMultiple={props.showMultiple}
          />
        )}
      </>
    )
  }

  return DeleteModal
}

export default withDeleteModal
